import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent {
  public employeeId!:string;
  public addForm!:FormGroup;
  constructor(
    private fb: FormBuilder,
    private appService: AppService,
    private dialogRef: MatDialogRef<MessageComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData:any,
    private commonService:CommonService,
    private recruiterService:RecruiterService
  ){}
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.addForm=this.fb.group({
      'tit':["",Validators.required],
      "msg":["",Validators.required]
    })
    if(this.dialogData){
      this.employeeId=this.dialogData.employee_id
    }
  }
  
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError( this.addForm,controlName, validationType);
  }
  onCancel(){
    this.dialogRef.close()
  }
  onSubmit(){
    if(this.addForm.valid==false){
      this.addForm.markAllAsTouched()
      return
    }
    let obj=this.addForm.value;
    obj["em_i"]= [this.employeeId]
    this.recruiterService.sendNotification(obj).subscribe({
      next: (success: any) => {
        //this.spinner.hide()
       this.appService.showToastMessage('success',success.msg);
       this.dialogRef.close({data_added:true})
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
}
